module.exports = __webpack_public_path__ + "assets/ea6f15f9d420f81e3b6c3d52c6b93b52.svg";